import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { CreateCardAccountStackRoutes, CreateCardAccountStackScreenProps } from './type';
import { CreateCardAccountWebTwoScreen } from './CreateCardAccountWebTwo.screen';
import { CreateCardAccountNativeTwoScreen } from './CreateCardAccountNativeTwo.screen';

export interface CreateCardAccountProps {}
export const CreateCardAccountPlaced: React.FC<CreateCardAccountStackScreenProps<CreateCardAccountStackRoutes.Placed>> = ({
  navigation,
  route
}) => {
  const { onLayout, data, returnData, refresh } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return <CreateCardAccountNativeTwoScreen onClose={onGoBack} data={data} returnData={returnData} refresh={refresh} />;
  }

  return <CreateCardAccountWebTwoScreen onClose={closeModal} onLayout={onLayout} data={data} returnData={returnData} refresh={refresh} />;
};
